import { environment } from '~env/environment';

export const METRO_ID_ORGANIZATION = environment.metroSellerId();
